import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { applyTenantTheme, loadBrandFromEnv } from "./tenantTheme";
import { configureTerms, loadTermsFromEnv } from "./terms";

// Apply this tenant's brand + terminology overrides before first paint.
// With no REACT_APP_BRAND_JSON / REACT_APP_TERMS_JSON set, both are no-ops.
applyTenantTheme(loadBrandFromEnv());
configureTerms(loadTermsFromEnv());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
